import { AbstractControl, FormGroup, ValidatorFn } from "@angular/forms";
import { Product } from "@libs/shares/models/models";
import { rpsMax, rpsMin, rpsMultiplier, validateRps } from "@libs/shares/models/product.model";

export const emailValidator = (): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValid = emailPattern.test(control.value);

    return isValid ? null : { invalidEmail: true };
  };
};
export const urlValidator = (): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const urlPattern = /^(https?:\/\/(www\.)?)?([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}(\/.*)?$/;
    if (!control.value || control.value?.length === 0) return null;
    const isValid = urlPattern.test(control.value);

    return isValid ? null : { invalidUrl: true };
  };
};

export const quantityValidator = (divisor: number): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value: { product: Product; quantity: number } = control.value;
    if (value === null || value === undefined) {
      return null; // Don't apply validation when there's no value
    }

    const isValid = value.quantity % divisor === 0;
    return isValid ? null : { multipleOf: true };
  };
};

export const multipleValidator = (divisor: number, min = 0): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const { value } = control;
    if (value === null || value === undefined) {
      return null; // Don't apply validation when there's no value
    }

    if (value <= min) {
      return null;
    }

    const isValid = value % divisor === 0;
    return isValid ? null : { multipleOf: true };
  };
};

export function atLeastOneCheckboxCheckedValidator(minRequired = 1): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const formGroup = control as FormGroup;
    let checked = 0;

    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.controls[key];

      if (control.value) {
        checked++;
      }
    });

    if (checked < minRequired) {
      return {
        requireCheckboxToBeChecked: true
      };
    }

    return null;
  };
}

export const rpsValidator: ValidatorFn = (control: AbstractControl) => {
  const { value } = control;
  if (value === null || value === undefined) {
    return null; // Don't apply validation when there's no value
  }
  try {
    validateRps(control.value);
  } catch (error: unknown) {
    if (error instanceof Error) {
      if (error.message === `RPS must be between ${rpsMin} and ${rpsMax}`) {
        return { rpsMinMax: true };
      }
      if (error.message === `RPS must be a multiple of ${rpsMultiplier}`) {
        return { rpsMultiple: true };
      }
    }
  }
  return null;
};
